/* eslint-disable no-undef */
// import * as CONSTANT from '../src/assets/script/constant'
const CryptoJS = require('crypto-js')
var pbkdf2 = require('pbkdf2-sha256')

export function getRandomRequestURI (uri) {
  return uri + '?rand =' + Math.random()
}

export function getSign (key, method, date, resource, contentType, md5, headers) {
  var param = method

  param += '\n'

  if (!md5) {
    md5 = ''
  }

  param += md5
  param += '\n'

  param += contentType
  param += '\n'

  param += date
  param += '\n'

  if (!headers) {
    headers = ''
  }

  if (headers != '') {
    param += headers
    // param += '\n'
  }

  param += resource

  // console.log('param is ', param)

  var words = CryptoJS.HmacSHA1(param, key)

  var base64String = CryptoJS.enc.Base64.stringify(words)

    // console.log(base64String);

  var ssig = base64String.substr(5, 10)

  var ssigEncode = encodeURIComponent(ssig)

    // console.log('ssigEncode is ', ssigEncode);

  return ssigEncode
}

export function getSsigUrl (method, url, contentType) {
//   let key = CONSTANT.AppKey,
let key = 'f5a3814579af960183656549678282d',
    date = '',
    md5 = '',
    headers = '',
    ssig

//   url += '?AppId=' + CONSTANT.AppId
url += '?AppId=' + '9a190425f6183186'

  ssig = getSign(key, method, date, url, contentType, md5, headers)

  url += '&ssig=' + ssig

  return url
}

export function getPdkdSign(url, body) {
  const host = window.location.href.split('/')[2]
  let appId = ''
  let appSecret = ''
  if(host === 'apps-test.lexar.com' || host === 'localhost:8080' || host === 'localhost:8084'){
    appId = "lexar_test_0002"
    appSecret = "l5al81l79rh960183r455vy679a2df8"
  }else{
    appId = "lexar_0002"
    appSecret = "wjmoh8fe35y2sjy5l84kb3zfgeq8c5x2"  //仰诚接口正式域名
  }
  const timestamp = parseInt(Date.parse(new Date()) / 1000)
  const nonce_divisor = 99
  const src = "lexar"+JSON.stringify(body)+appSecret+timestamp
  const iterations = (timestamp % nonce_divisor) + 1  // 取余 1-99次
  const dk = pbkdf2(src, appSecret, iterations, 64)
  const sign = dk.toString('base64').replace(/\+/g, '-').replace(/\//g, "_")
  return {
    options: {
      'X-API-SIGN': sign
    },
    timestamp,
    appId
  }
}

/**
 * @description 判断是否是IOS
 * @returns {boolean}
 */
export function isIOS () {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/api/helper.js